import axios from 'axios'
import { attributes } from '../../imports'
import { FETCHING, FETCHED, OUTDATED, LOCALE_CHANGED, STEAM_SAVED } from './constants'
import { getSteam, getLanguage, getLocalizedAdsForLocale } from '../../selectors'

export function fetching(locale) {
    return {
        type: FETCHING,
        payload: locale,
    }
}

export function fetched(locale, ads) {
    return {
        type: FETCHED,
        payload: { locale, ads },
    }
}

export function fetch(locale) {
    return (dispatch, getState) => {
        // Let know that I am fetching
        dispatch(fetching(locale))

        const isSteam = getSteam(getState())

        // Now create the URL:
        const origin = isSteam ? attributes.steamOrigin : attributes.defaultOrigin
        const url = attributes.url.replace('{origin}', origin).replace('{locale}', locale)

        // Do the actual fetching
        axios
            .get(url, {
                headers: { 'Accept-Language': locale },
            })
            .then((response) => {
                // Make sure that we received a valid response status
                // otherwise throw an error with the response status
                if (response.status !== 200) throw Error(response.status)

                // now we need to format the response
                let ads = []
                if (response.data.response.success === 1) {
                    ads = response.data.response.campaigns.map(v => ({
                        id: v.cID,
                        src: v.creative_data.image_url,
                        link: v.creative_data.click_url,
                    }))
                } else {
                    console.info('No creatives were found in response')
                }

                // Update the state with the new response
                dispatch(fetched(locale, ads))
            })
            .catch((error) => {
                console.info(`Error occurred while fetching ad content: ${error.message}`)
            })
    }
}

export function outdated() {
    return (dispatch, getState) => {
        // Mark all languages as outdated
        dispatch({ type: OUTDATED })
        // Refetch the current language
        dispatch(fetch(getLanguage(getState())))
    }
}

export function languageChanged(locale) {
    return (dispatch, getState) => {
        dispatch({ type: LOCALE_CHANGED, payload: locale })
        // First get the current value of the selected language
        const localizedAds = getLocalizedAdsForLocale(getState(), locale)

        // If we are already fetching, then there is no need to
        // start fetching
        if (localizedAds.fetching) return

        // If we are not outdated, then there is no need to update
        if (!localizedAds.outdated) return

        // Either we have no data or outdated data and thus we want to fetch
        dispatch(fetch(locale))
    }
}

export function steamChanged(steamStartup) {
    return (dispatch, getState) => {
        const state = getState()
        const locale = getLanguage(state)
        const isSteam = getSteam(state)
        if (isSteam === steamStartup) return

        dispatch({ type: STEAM_SAVED, payload: steamStartup })
        dispatch(fetch(locale))
    }
}



// WEBPACK FOOTER //
// ./src/features/Ads/data/feed/actions.js